import React from 'react';
import { GoalOptions } from './goalOptions';
import { GoalTargets } from './goalTargets';
import { goalDataTypeEnums } from '../../../../../../utils';
import { useSelector } from 'react-redux';

export const Targets = ({ requestParams }) => {
    const goalById = useSelector((state) => state.goals.goalById);

    return (
        <div>
            <GoalTargets requestParams={requestParams} />

            {goalById?.dataType !== goalDataTypeEnums?.DURATION &&
              goalById?.dataType !== goalDataTypeEnums?.FREQUENCY &&
               goalById?.dataType !== goalDataTypeEnums?.SCORE &&
                goalById?.dataType !== goalDataTypeEnums?.RATE &&
                 goalById?.dataType !== goalDataTypeEnums?.IRT &&
                <GoalOptions />
            }
        </div>
    );
};
